import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api_call"; // ✅ central API helper
import "./Dashboard.css";

export default function EditUser() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    contact: "",
    escalationEmail: "",
    businessUnit: "",
    businessUnitId: "",
    department: "",
    departmentId: "",
    status: "1",
  });
  const [displayStatus, setDisplayStatus] = useState("1");
  const [originalData, setOriginalData] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [deptFocused, setDeptFocused] = useState(false);
  const [unitFocused, setUnitFocused] = useState(false);

  const [businessUnits, setBusinessUnits] = useState([]);
  const [filteredBusinessUnits, setFilteredBusinessUnits] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [popup, setPopup] = useState({ visible: false, type: "", value: "" });
  const [suspendPopup, setSuspendPopup] = useState(false); // ✅ ADD
  const [pendingStatus, setPendingStatus] = useState("1");

  const navigate = useNavigate();
  const admin = useMemo(() => JSON.parse(localStorage.getItem("user") || "{}"), []);
  const adminId = admin.usrlst_id;
  const editUserData = useMemo(() => JSON.parse(localStorage.getItem("editUserData") || "{}"), []);
  const editingUserId = editUserData.usrlst_id || editUserData.id;

  // Restore temp form or initial data
  useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("editUserTempForm") || "{}");

  // 1️⃣ If there's a temp saved form (coming back from Add BU/Dept)
  if (saved && Object.keys(saved).length > 0) {
    setFormData(saved);
    setOriginalData(saved);
    setDisplayStatus(saved.status);
  } 
  // 2️⃣ Else if coming from /add-department (returnBUName/returnDeptName)
  else if (localStorage.getItem("returnBUName") || localStorage.getItem("returnDeptName")) {
    const returnBUName = localStorage.getItem("returnBUName");
    const returnDeptName = localStorage.getItem("returnDeptName");

    setFormData(prev => ({
      ...prev,
      businessUnit: returnBUName || "",
      department: returnDeptName || "",
    }));

    if (returnBUName) fetchDepartments(returnBUName, true);
  } 
  // 3️⃣ Else if coming from /users → populate from editUserData
  else if (editUserData) {
    const initial = {
      username: editUserData.name || "",
      email: editUserData.email || "",
      contact: editUserData.contact || "",
      escalationEmail: editUserData.escalation_mail || "",
      businessUnit: editUserData.business_unit || "",
      businessUnitId: editUserData.business_unit_id || "",
      department: editUserData.department || "",
      departmentId: editUserData.department_id || "",
      status: String(editUserData.login_flag ?? "1"),
    };
    setFormData(initial);
    setOriginalData(initial);
    setDisplayStatus(initial.status);

    if (initial.businessUnit) fetchDepartments(initial.businessUnit, false);
  }
}, [editUserData]);


   

  // Admin check
  useEffect(() => {
    if (!adminId || admin?.usrlst_role?.toLowerCase() !== "admin") {
      alert("Access denied");
      navigate("/", { replace: true });
    }
  }, [navigate, adminId, admin]);

  // Fetch Business Units
  useEffect(() => {
    if (!adminId) return;

    apiFetch("/user/business_unit/all")
      .then((data) => {
        if (!Array.isArray(data)) return;

        setBusinessUnits(data);
        setFilteredBusinessUnits(data);

        const fromAddBU = localStorage.getItem("fromAddBU");
        const fromAddDept = localStorage.getItem("fromAddDept");

        if ((fromAddBU || fromAddDept) && data.length > 0) {
          localStorage.removeItem("fromAddBU");
          localStorage.removeItem("fromAddDept");
          localStorage.removeItem("customBU");
          localStorage.removeItem("customDept");
          localStorage.removeItem("selectedBusinessUnitId");
          localStorage.removeItem("page");

          const fromAddDept = localStorage.getItem("fromAddDept");
const returnBUName = localStorage.getItem("returnBUName");

if (fromAddDept && returnBUName) {
  const matchedBU = data.find(
    bu => bu.usrbu_business_unit_name === returnBUName
  );

  if (matchedBU) {
    setFormData(prev => ({
      ...prev,
      businessUnit: matchedBU.usrbu_business_unit_name,
      businessUnitId: matchedBU.usrbu_id,
    }));

    fetchDepartments(matchedBU.usrbu_business_unit_name);
  }
}

        } else if (editUserData?.business_unit) {
          fetchDepartments(editUserData.business_unit, false);
        }
      })
      .catch((err) => console.error("BU fetch error:", err));
  }, [adminId]);

  // Fetch Departments
  const fetchDepartments = async (buName, autoSelectDept = false) => {
  if (!buName) return;

  try {
    const data = await apiFetch("/user/departments/all");
    if (!Array.isArray(data)) return;

    // Filter departments for the selected BU
    const filtered = data
      .filter((d) => d.usrbu_business_unit_name === buName)
      .sort((a, b) => a.usrdept_department_name.localeCompare(b.usrdept_department_name));

    setDepartments(filtered);
    setFilteredDepartments(filtered);

    // 1️⃣ Check if coming from Add Department (localStorage returnDeptName)
    const returnDeptName = localStorage.getItem("returnDeptName");
    const returnBUName = localStorage.getItem("returnBUName");

    if (autoSelectDept && returnDeptName && returnBUName === buName) {
      const matchedDept = filtered.find(d => d.usrdept_department_name === returnDeptName);
      if (matchedDept) {
        setFormData(prev => ({
          ...prev,
          department: matchedDept.usrdept_department_name,
          departmentId: matchedDept.usrdept_id,
        }));

        // Cleanup after success
        ["fromAddDept", "returnBUName", "returnDeptName", "customDept", "page"].forEach(k =>
          localStorage.removeItem(k)
        );
        return;
      }
    }

    // 2️⃣ If editing user from /users → select existing department if matches BU
    if (!autoSelectDept && editUserData?.department && buName === editUserData.business_unit) {
      const matchedDept = filtered.find(d => d.usrdept_department_name === editUserData.department);
      if (matchedDept) {
        setFormData(prev => ({
          ...prev,
          department: matchedDept.usrdept_department_name,
          departmentId: matchedDept.usrdept_id,
        }));
      }
    }
  } catch (err) {
    console.error("Error fetching departments:", err);
    setDepartments([]);
    setFilteredDepartments([]);
  }
};


  // Input change handler
  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === "contact") value = value.replace(/\D/g, "").slice(0, 10);
    else if (name !== "email" && name !== "escalationEmail")
      value = value.replace(/\s{2,}/g, " ").replace(/^\s+/, "");

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "businessUnit") {
  setFilteredBusinessUnits(
   businessUnits.filter((b) =>
  b.usrbu_business_unit_name.toLowerCase().includes(value.toLowerCase())
)

  );

  setFormData((prev) => ({
    ...prev,
    department: "",
    departmentId: "",
    businessUnitId: value === prev.businessUnit ? prev.businessUnitId : "",
  }));

  setFilteredDepartments([]);
}


    if (name === "department" && formData.businessUnit) {
      setFilteredDepartments(
        departments.filter((d) =>
          d.usrdept_department_name.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  const handleSuggestionClick = (name, value) => {
    if (name === "businessUnit") {
      setFormData((prev) => ({
        ...prev,
        businessUnit: value.usrbu_business_unit_name,
        businessUnitId: value.usrbu_id,
        department: "",
        departmentId: "",
      }));
      fetchDepartments(value.business_unit_name);
      setFilteredBusinessUnits([]);
      setFilteredDepartments([]);
    } else if (name === "department") {
      setFormData((prev) => ({
        ...prev,
        department: value.usrdept_department_name,
        departmentId: value.usrdept_id,
      }));
      setFilteredDepartments([]);
      setPopup({ visible: false, type: "", value: "" });
    }
  };

  const handleCustomCheck = (fieldName) => {
  const value = formData[fieldName]?.trim();
  if (!value) return;

 if (fieldName === "businessUnit") {
  const matchedBU = businessUnits.find(
    (b) =>
      b.usrbu_business_unit_name.toLowerCase() === value.toLowerCase()
  );

  // ✅ Case 1: User typed an EXISTING BU manually
  if (matchedBU) {
    setFormData((prev) => ({
      ...prev,
      businessUnit: matchedBU.usrbu_business_unit_name,
      businessUnitId: matchedBU.usrbu_id,
      department: "",
      departmentId: "",
    }));

    fetchDepartments(matchedBU.usrbu_business_unit_name);
    return;
  }

  // ✅ Case 2: Truly NEW BU → show popup
  const originalBU = originalData?.businessUnit?.toLowerCase();
  if (value.toLowerCase() !== originalBU) {
    setPopup({ visible: true, type: "businessUnit", value });
  }
}


  if (fieldName === "department") {
    const exists = departments.some(
      (d) =>
        d.usrdept_department_name.toLowerCase() === value.toLowerCase()
    );

    const originalDept = originalData?.department?.toLowerCase();

    if (!exists && value.toLowerCase() !== originalDept && formData.businessUnit) {
      setPopup({ visible: true, type: "department", value });
    }
  }
};



  const handlePopupYes = () => {
    localStorage.setItem("editUserTempForm", JSON.stringify(formData));

    if (popup.type === "businessUnit") {
      localStorage.setItem("customBU", popup.value);
      localStorage.setItem("fromAddBU", "true");
      localStorage.setItem("page", "3");
      localStorage.setItem("BUpage", "3");
      navigate("/add-bu");
    } else if (popup.type === "department") {
      localStorage.setItem("customDept", popup.value);
      localStorage.setItem("fromAddDept", "true");
      localStorage.setItem("page", "3");
      navigate(`/add-department?businessUnitId=${formData.businessUnitId}`);
    }
  };

  const handlePopupNo = () => {
    if (popup.type === "businessUnit")
      setFormData((prev) => ({ ...prev, businessUnit: "", businessUnitId: "" }));
    else setFormData((prev) => ({ ...prev, department: "", departmentId: "" }));
    setPopup({ visible: false, type: "", value: "" });
  };

  const isSaveEnabled = originalData && JSON.stringify(originalData) !== JSON.stringify(formData);

  const validateNow = () => {
    const e = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.username.trim()) e.username = "User name is required";
    if (!formData.email.trim()) e.email = "Email is required";
    else if (!emailRegex.test(formData.email)) e.email = "Invalid email";

    if (!formData.contact.trim()) e.contact = "Contact required";
    else if (formData.contact.length !== 10) e.contact = "Contact must be exactly 10 digits";

    if (!formData.businessUnit.trim()) e.businessUnit = "Business Unit required";
    if (!formData.department.trim()) e.department = "Department required";

    if (!formData.escalationEmail.trim()) e.escalationEmail = "Escalation email required";
    else if (!emailRegex.test(formData.escalationEmail)) e.escalationEmail = "Invalid escalation email";

    return e;
  };

  const handleFocus = (name) => {
  if (name === "businessUnit") {
    setUnitFocused(true);

    // 🔑 ALWAYS populate list on focus
    setFilteredBusinessUnits(businessUnits);
  }

  if (name === "department") {
    setDeptFocused(true);

    if (formData.businessUnit) {
      setFilteredDepartments(departments);
    }
  }
};





  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    const v = validateNow();
    setErrors(v);
    if (Object.keys(v).length > 0) return;

     try {
    const payload = {
  name: formData.username,
  email: formData.email,
  contact: formData.contact,
  department_id: formData.departmentId,
  business_unit_id: formData.businessUnitId,
  login_flag: parseInt(formData.status, 10), // 🔥 IMPORTANT
};




      apiFetch(`/user/update/${editingUserId}`, {

        method: "PUT",
        body: JSON.stringify(payload),
      });

      setSuccessMsg("✅ User updated successfully!");
      [
        "editUserTempForm",
        "fromAddBU",
        "fromAddDept",
        "customBU",
        "customDept",
        "selectedBusinessUnitId",
        "page",
        "editUserData",
      ].forEach((k) => localStorage.removeItem(k));

      setTimeout(() => navigate("/user"), 800);
    } catch (err) {
      setErrors({ api: err.message || "Failed to update user" });
    }
  };
    // ✅ NEW: Status change with confirmation
   const handleStatusChange = (e) => {
    const value = e.target.value;

    if (value === "0") {
      setSuspendPopup(true);
    } else {
      setFormData((prev) => ({ ...prev, status: "1" }));
    }
  };

  const confirmSuspend = () => {
    setFormData((prev) => ({ ...prev, status: "0" }));
    setSuspendPopup(false);
  };

  const cancelSuspend = () => {
    setFormData((prev) => ({ ...prev, status: originalData.status }));
    setSuspendPopup(false);
  };


  const handleDelete = async () => {
    if (!window.confirm("Delete user?")) return;

    try {
      await apiFetch(`/user_delete/${editingUserId}`, { method: "DELETE" });
      setSuccessMsg("✅ User deleted successfully!");
      setTimeout(() => navigate("/user"), 800);
    } catch (err) {
      setErrors({ api: err.message || "Failed to delete user" });
    }
  };

  const handleBackup = () => {
    alert("Backup taken.");
  };

  return (
    <div className="edit-user">
      <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Edit User</h2>

        {errors.api && <div className="login-error">{errors.api}</div>}
        {successMsg && <div className="success-msg">{successMsg}</div>}

       <form onSubmit={handleSubmit} className="add-user-form">
  {/* Username */}
  <label>
    User Name
    <input
      type="text"
      name="username"
      value={formData.username}
      onChange={handleInputChange}
    />
    {submitted && errors.username && (
      <p className="error">{errors.username}</p>
    )}
  </label>

  {/* Status Indicator (NOT LIVE) */}
  <div style={{ marginBottom: 16, textAlign: "right" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        justifyContent: "flex-end",
      }}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: displayStatus === "1" ? "green" : "red",
        }}
      />
      <span style={{ fontWeight: 600 }}>
        {displayStatus === "1" ? "Active" : "Suspended"}
      </span>
    </div>
  </div>

  {/* Email */}
  <label>
    E-Mail Address
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleInputChange}
    />
    {submitted && errors.email && (
      <p className="error">{errors.email}</p>
    )}
  </label>

  {/* Contact */}
  <label>
    Contact Number
    <input
      type="text"
      name="contact"
      value={formData.contact}
      onChange={handleInputChange}
      maxLength={10}
    />
    {submitted && errors.contact && (
      <p className="error">{errors.contact}</p>
    )}
  </label>

  {/* Business Unit */}
  <label className="autocomplete">
    Business Unit
    <input
      type="text"
      name="businessUnit"
      value={formData.businessUnit}
      onChange={handleInputChange}
      autoComplete="off"
      onFocus={() => handleFocus("businessUnit")}
      onBlur={() => {
        setUnitFocused(false);
        setTimeout(() => handleCustomCheck("businessUnit"), 150);
      }}
    />

    {submitted && errors.businessUnit && (
      <p className="error">{errors.businessUnit}</p>
    )}

    {unitFocused && (
      <ul className="suggestions">
        {filteredBusinessUnits.length > 0 ? (
          filteredBusinessUnits.map((unit) => (
            <li
              key={unit.usrbu_id}
              onMouseDown={() =>
                handleSuggestionClick("businessUnit", unit)
              }
            >
              {unit.usrbu_business_unit_name}
            </li>
          ))
        ) : (
          <li className="no-suggestions">No Business Unit Found</li>
        )}
      </ul>
    )}
  </label>

  {/* Department */}
  <label className="autocomplete">
    Department
    <input
      type="text"
      name="department"
      value={formData.department}
      onChange={handleInputChange}
      disabled={!formData.businessUnitId}
      autoComplete="off"
      onFocus={() => handleFocus("department")}
      onBlur={() => {
        setDeptFocused(false);
        setTimeout(() => handleCustomCheck("department"), 150);
      }}
    />

    {submitted && errors.department && (
      <p className="error">{errors.department}</p>
    )}

    {deptFocused && (
      <ul className="suggestions">
        {filteredDepartments.length > 0 ? (
          filteredDepartments.map((dept) => (
            <li
              key={dept.usrdept_id}
              onMouseDown={() =>
                handleSuggestionClick("department", dept)
              }
            >
              {dept.usrdept_department_name}
            </li>
          ))
        ) : (
          <li className="no-suggestions">No Department Found</li>
        )}
      </ul>
    )}
  </label>

  {/* Escalation Email (LOCKED ONLY FIELD) */}
  <label>
    Escalation Email
    <input
      type="email"
      name="escalationEmail"
      value={formData.escalationEmail}
      readOnly
      style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
    />
    {submitted && errors.escalationEmail && (
      <p className="error">{errors.escalationEmail}</p>
    )}
  </label>

  <label />

  {/* Status */}
  <label>
    Change Status
    <select value={formData.status} onChange={handleStatusChange}>
      <option value="1">Active</option>
      <option value="0">Suspend</option>
    </select>
  </label>

  {/* Actions */}
  <div className="action-buttons">
    <button
      type="submit"
      className="submit-btn"
      disabled={!isSaveEnabled}
      style={{
        opacity: isSaveEnabled ? 1 : 0.5,
        cursor: isSaveEnabled ? "pointer" : "not-allowed",
      }}
    >
      Save Changes
    </button>

    <button
      type="button"
      className="submit-btn delete-btn"
      onClick={handleDelete}
    >
      Delete User
    </button>
  </div>

  <div className="backup-container">
    <button
      type="button"
      className="backup-btn"
      onClick={handleBackup}
    >
      Take Backup
    </button>
  </div>
</form>

          {suspendPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <p>
                Do you want to suspend this user?
                <br />
                <strong>They won’t be able to login until activated.</strong>
              </p>
              <div className="popup-buttons">
                <button onClick={confirmSuspend}>Yes, Suspend</button>
                <button onClick={cancelSuspend}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {/* Popup */}
        {popup.visible && (
          <div className="popup-overlay">
            <div className="popup">
              <p>
                Add "{popup.value}" as a new {popup.type === "businessUnit" ? "Business Unit" : "Department"}?
              </p>
              <div className="popup-buttons">
                <button className="popup-yes" onClick={handlePopupYes}>Yes</button>
                <button className="popup-no" onClick={handlePopupNo}>No</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
